import React from "react";

const Footer = () => (
  <div id="page-footer">
    <p>
      <a href="http://jimfarrugia.com" title="Jim Farrugia's Portfolio">
        By Jim Farrugia
      </a>
    </p>
  </div>
);

export default Footer;
